/* eslint import/no-namespace:0 */
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux';
import { PropTypes } from "prop-types"
import { reduxForm, Field, change, formValueSelector, getFormSyncErrors } from 'redux-form'
import { Col, FormGroup, Row } from "react-bootstrap"
import Dialog from 'react-bootstrap-dialog'
import { isEmpty } from '../../../../utils/functions';
import { fetchMember, updateAlternate, setSearchMode, fetchAlternateParentEmail } from '../../../../redux/actions/action_postEvent';
import { renderField } from '../../../../modules/components/fieldcomponent'
import { orange, style, blue, red, lightgray, warning } from '../../../../utils/constants'
import InfoSaved from '../../../season/components/InfoSaved'
import ErrorList from '../../../season/components/ErrorList'

const FormName = 'postevent'
const spanClassName = `col-sm-12`

class UpdateAlternates extends Component {

  constructor(props) {
    super(props);
    this.state = {
      saved: false
    }
    this.handleUpdateAlternateSave = this.handleUpdateAlternateSave.bind(this);
    this.handleGetMemberInfo = this.handleGetMemberInfo.bind(this);
    this.handleUpdateCancel = this.handleUpdateCancel.bind(this);
  }

  handleGetMemberInfo(event) {
    const { dispatch, alternateUpdateData } = this.props;
    const { memberidprefix, memberidsuffix, alternateId } = alternateUpdateData.alternate[0];
    event.preventDefault();
    dispatch(setSearchMode(true));
    dispatch(fetchMember(memberidprefix, memberidsuffix));
    dispatch(fetchAlternateParentEmail(alternateId));
  }
  handleResetMember() {
    const { memberName, email, memberState, city, calculatedAge, gender, calculatedDivision,
      parentEmailAddress, dispatch, norecordsfound, syncErrors, memberRetrieved } = this.props
    if (!isEmpty(memberName)) {
      dispatch(change(FormName, 'memberName', ''))
    }
    if (!isEmpty(email)) {
      dispatch(change(FormName, 'email', ''))
    }
    if (!isEmpty(memberState)) {
      dispatch(change(FormName, 'memberState', ''))
    }
    if (!isEmpty(city)) {
      dispatch(change(FormName, 'city', ''))
    }
    if (!isEmpty(calculatedAge)) {
      dispatch(change(FormName, 'calculatedAge', ''))
    }
    if (!isEmpty(gender)) {
      dispatch(change(FormName, 'gender', ''))
    }
    if (!isEmpty(calculatedDivision)) {
      dispatch(change(FormName, 'calculatedDivision', ''))
    }
    if (!isEmpty(parentEmailAddress)) {
      dispatch(change(FormName, 'parentEmailAddress', ''))
    }
    if (memberRetrieved) {
      dispatch(change(FormName, 'memberRetrieved', false))
    }
    if (norecordsfound) {
      dispatch(change(FormName, 'norecordsfound', false))
    }
    if (syncErrors) {
      dispatch(change(FormName, 'syncErrors', null))
    }
  }

  handleUpdateAlternateSave(e) {
    e.preventDefault();
    const {
      dispatch,
      alternateUpdateData,
      onAlternateUpdatedData,
      onAlternateUpdateSave,
      address1,
      address2,
      birthDate,
      city,
      country,
      phoneNumber,
      email,
      firstName,
      lastName,
      memberState,
      zip,
      gender,
      middleInitial,
      parentEmailAddress,
      calculatedDivision,
      calculatedDivisionId
    } = this.props;
    const { alternateId, memberidprefix, memberidsuffix } = alternateUpdateData.alternate[0];
    const alternate = {
      alternateId: alternateId,
      addressLine1: address1,
      addressLine2: address2,
      dob: birthDate,
      city: city,
      country: country,
      phoneNumber: phoneNumber,
      emailAddress: email,
      firstName: firstName,
      lastName: lastName,
      middleInitial: middleInitial,
      gender: gender,
      state: memberState,
      zip: zip,
      parentGuardianEmail: parentEmailAddress,
      divisionId: calculatedDivisionId,
      calculatedDivision: calculatedDivision,
      membershipId: `${memberidprefix}-${memberidsuffix}`
    }
    dispatch(updateAlternate(alternateId, alternate));
    this.handleResetMember();
    onAlternateUpdateSave(alternate.membershipId);
    onAlternateUpdatedData(alternate);
  }

  handleUpdateCancel() {
    const { onAlternateUpdateCancel } = this.props;
    this.handleResetMember();
    onAlternateUpdateCancel();
  }

  render() {
    const { saved } = this.state
    const { alternateUpdateData, syncErrors, norecordsfound, searchMode, memberRetrieved } = this.props;
    const errors = Object.values(syncErrors);
    const memberidprefix = alternateUpdateData.alternate[0].memberidprefix;
    const memberidsuffix = alternateUpdateData.alternate[0].memberidsuffix;

    return (

      <div style={{ backgroundColor: 'white', padding: '10px', border: `1px solid ${lightgray}` }}>
        <h4 style={{ color: blue }}> {'Update Alternate'}</h4 >
        <div />
        <Row>
          <Col xs={12}>
            <Dialog ref={(el) => { this.dialog = el }} />
            {(errors.length > 0) && <ErrorList errors={errors} />}
            {
              norecordsfound !== undefined && norecordsfound &&
              <span className={spanClassName} style={{ color: warning, float: 'left' }}>
                <i className='fa fa-info-circle' style={{ paddingLeft: '0px', marginTop: '0px' }} />&nbsp;&nbsp;Athlete not found
              </span>
            }
            <Col md={12} lg={6} style={{ padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
              <FormGroup>
                <label className={style.lblattrsWide}>USBC Member ID</label>
                <Col sm={3} md={3} lg={3}>
                  <input
                    value={memberidprefix}
                    className="form-control no-spinners"
                    placeholder='Prefix (#)'
                    type='number'
                    component="input"
                    disabled='disabled'
                  />
                </Col>
                <Col sm={3} md={3} lg={4} style={{ marginLeft: '-28px', minWidth: '130px' }}>
                  <input
                    className="form-control no-spinners"
                    placeholder='Suffix (#)'
                    component="input"
                    type='number'
                    value={memberidsuffix}
                    disabled='disabled'
                  />
                </Col>
                <Col sm={1} lg={1} md={1}>
                  <span className="input-group-btn" sm={1} md={1} lg={1}>
                    <button
                      type="button"
                      className="btn btn-default"
                      id='button'
                      style={
                        {
                          marginLeft: '-32px', marginTop: '-1px', minHeight: '37px', maxWidth: '41px',
                          borderRadius: '0', color: orange
                        }
                      }
                      onClick={this.handleGetMemberInfo}
                      disabled={isEmpty(memberidprefix) || isEmpty(memberidsuffix) || errors.length > 0}>

                      <i className={searchMode === true ? "fa fa-spinner fa-spin" : "fa fa-search"} aria-hidden="true" />
                    </button>
                  </span>
                </Col>
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Name</label>
                <Field
                  name='memberName'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Email</label>
                <Field
                  name='email'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>State</label>
                <Field
                  name='memberState'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>City</label>
                <Field
                  name='city'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
            </Col>
            <Col md={12} lg={6} style={{ padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
              <FormGroup>
                <label className={style.lblattrs}>Age</label>
                <Field
                  name='calculatedAge'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Gender</label>
                <Field
                  name='gender'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Calculated Division</label>
                <Field
                  name='calculatedDivision'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Parent/Guardian Email</label>
                <Field
                  name='parentEmailAddress'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                />
              </FormGroup>
            </Col>
            <FormGroup >
              <Col smOffset={5} sm={10}>
                <button type="button" className="btn btn-default" style={{ color: blue, fontWeight: 800, marginTop: '15px' }} onClick={this.handleUpdateAlternateSave} disabled={errors.length > 0 || !memberRetrieved}>
                  <i className={saved ? 'fa fa-spinner fa-spin' : "fa fa-save"} aria-hidden="true" /> &nbsp;&nbsp;Update Changes
                </button>
                <button type="button" className="btn btn-default" style={{ color: red, fontWeight: 800, marginTop: '15px', marginLeft: '10px' }} onClick={this.handleUpdateCancel}>
                  <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Cancel
                </button>
                {
                  saved && (<InfoSaved custommessage='Saved successfully.' />)
                }
              </Col>
            </FormGroup>
          </Col>
        </Row>
      </div>)
  }
}
UpdateAlternates.propTypes = {
  dispatch: PropTypes.func,
  alternateUpdateData: PropTypes.func,
  onAlternateUpdatedData: PropTypes.func,
  onAlternateUpdateSave: PropTypes.func,
  onAlternateUpdateCancel: PropTypes.func,
  memberName: PropTypes.string,
  email: PropTypes.string,
  memberState: PropTypes.string,
  city: PropTypes.string,
  calculatedAge: PropTypes.number,
  gender: PropTypes.string,
  calculatedDivision: PropTypes.string,
  calculatedDivisionId: PropTypes.string,
  parentEmailAddress: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  birthDate: PropTypes.string,
  country: PropTypes.string,
  phoneNumber: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  zip: PropTypes.string,
  norecordsfound: PropTypes.bool,
  middleInitial: PropTypes.string,
  memberRetrieved: PropTypes.bool,
  searchMode: PropTypes.bool,
  syncErrors: PropTypes.object
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setSearchMode,
    fetchMember,
    fetchAlternateParentEmail,
    updateAlternate
  }, dispatch)
}

function mapStateToProps(state, ownProps) {

  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const syncErrors = getFormSyncErrors(formName)(state)
  const searchMode = selector(state, 'searchMode')
  const memberidprefix = selector(state, 'memberidprefix')
  const memberidsuffix = selector(state, 'memberidsuffix')
  const memberName = selector(state, 'memberName')
  const email = selector(state, 'email')
  const memberState = selector(state, 'memberState')
  const city = selector(state, 'city')
  const calculatedAge = selector(state, 'calculatedAge')
  const gender = selector(state, 'gender')
  const calculatedDivision = selector(state, 'calculatedDivision')
  const calculatedDivisionId = selector(state, 'calculatedDivisionId')
  const parentEmailAddress = selector(state, 'parentEmailAddress')
  const address1 = selector(state, 'address1')
  const address2 = selector(state, 'address2')
  const birthDate = selector(state, 'birthDate')
  const country = selector(state, 'country')
  const phoneNumber = selector(state, 'phoneNumber')
  const firstName = selector(state, 'firstName')
  const lastName = selector(state, 'lastName')
  const middleInitial = selector(state, 'middleInitial')
  const zip = selector(state, 'zip')
  const memberRetrieved = selector(state, 'memberRetrieved')
  return {
    syncErrors,
    searchMode,
    memberidprefix,
    memberidsuffix,
    memberName,
    email,
    memberState,
    city,
    calculatedAge,
    gender,
    calculatedDivision,
    calculatedDivisionId,
    parentEmailAddress,
    address1,
    address2,
    birthDate,
    country,
    phoneNumber,
    firstName,
    lastName,
    middleInitial,
    zip,
    memberRetrieved
  }
}
function validate(values) {
  const errors = []
  const { parentEmailAddress, memberRetrieved, calculatedAge, calculatedDivision, calculatedDivisionId } = values
  let errorCounter = 0;
  if (memberRetrieved) {
    if (calculatedAge < 18 && !parentEmailAddress) {
      errors[errorCounter++] = 'Parent/Guardian email is required for athletes under 18'
    }
    if (!isEmpty(parentEmailAddress) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(parentEmailAddress)) {
      errors[errorCounter++] = 'Parent/Guardian email is invalid'
    }
    if (isEmpty(calculatedDivision)) {
      errors[errorCounter++] = 'The Division through which the Athlete is selected to advance does not match the athletes division based on their Date of Birth and Gender'
    }
    if (isEmpty(calculatedDivisionId) && !isEmpty(calculatedDivision)) {
      errors[errorCounter++] = 'A division could not be found based on athletes Date of Birth and Gender'
    }
  }
  return errors
}
export default reduxForm({
  validate,
  form: FormName,
  destroyOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(UpdateAlternates))



// WEBPACK FOOTER //
// ./src/containers/postevent/components/recordAthletes/updateAlternates.js